<div [class]="rootClasses()" role="status" [attr.aria-label]="ariaLabel() || 'Loading'">
  @switch (variant()) {
    @case ('metric') {
      <div
        class="gr-widget-loader-metric flex w-full flex-col justify-center gap-2"
        aria-hidden="true"
      >
        <div class="flex w-full items-center justify-between gap-3">
          <gr-skeleton-loader styleClass="gr-widget-loader-value w-2/5" />
          <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-badge flex-none" />
        </div>
        <gr-skeleton-loader styleClass="gr-widget-loader-detail w-3/5" />
      </div>
    }

    @case ('donut') {
      <div
        class="gr-widget-loader-legend mb-3 flex w-full flex-none items-center justify-center gap-3"
        aria-hidden="true"
      >
        @for (item of legendItems; track $index) {
          <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-legend-item flex-none" />
        }
      </div>

      <div
        class="gr-widget-loader-plot flex min-h-16 w-full flex-auto items-center justify-center overflow-hidden"
        aria-hidden="true"
      >
        <div class="relative flex items-center justify-center">
          <svg class="gr-widget-loader-ring" viewBox="0 0 40 40" focusable="false">
            <circle class="gr-widget-loader-ring-track" cx="20" cy="20" r="16" />
            <circle
              class="gr-widget-loader-ring-arc"
              cx="20"
              cy="20"
              r="16"
              pathLength="100"
            />
          </svg>

          <div class="absolute inset-0 flex flex-col items-center justify-center gap-1">
            <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-donut-label" />
            <gr-skeleton-loader styleClass="gr-widget-loader-donut-value" />
          </div>
        </div>
      </div>
    }

    @case ('bar-horizontal') {
      <div
        class="gr-widget-loader-rows gr-widget-loader-reveal flex w-full flex-auto flex-col justify-center gap-3"
        aria-hidden="true"
      >
        @for (width of rowWidths; track $index) {
          <div class="flex w-full items-center gap-3">
            <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-row-label flex-none" />
            <span class="gr-widget-loader-row-track block flex-auto">
              <span class="gr-widget-loader-row-bar block h-full" [style.width.%]="width"></span>
            </span>
          </div>
        }
      </div>
    }

    @case ('bar') {
      <div class="gr-widget-loader-plot relative min-h-16 w-full flex-auto" aria-hidden="true">
        <span class="gr-widget-loader-grid absolute inset-0"></span>

        <div
          class="gr-widget-loader-bars gr-widget-loader-reveal absolute inset-0 flex items-end justify-between gap-2"
        >
          @for (height of barHeights; track $index) {
            <span class="gr-widget-loader-bar block flex-auto" [style.height.%]="height"></span>
          }
        </div>
      </div>

      <div
        class="gr-widget-loader-axis mt-3 flex w-full flex-none items-center justify-between gap-2"
        aria-hidden="true"
      >
        @for (tick of axisTicks; track $index) {
          <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-tick" />
        }
      </div>
    }

    @default {
      <div class="gr-widget-loader-plot relative min-h-16 w-full flex-auto" aria-hidden="true">
        <span class="gr-widget-loader-grid absolute inset-0"></span>

        <svg
          class="gr-widget-loader-svg gr-widget-loader-reveal absolute inset-0 h-full w-full"
          viewBox="0 0 100 40"
          preserveAspectRatio="none"
          focusable="false"
        >
          <defs>
            <linearGradient [attr.id]="gradientId" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="currentColor" stop-opacity="0.28" />
              <stop offset="1" stop-color="currentColor" stop-opacity="0" />
            </linearGradient>
          </defs>

          <path class="gr-widget-loader-area" [attr.d]="areaPath" [attr.fill]="areaFill" />
          <path
            class="gr-widget-loader-line"
            [attr.d]="linePath"
            vector-effect="non-scaling-stroke"
          />
        </svg>
      </div>

      <div
        class="gr-widget-loader-axis mt-3 flex w-full flex-none items-center justify-between gap-2"
        aria-hidden="true"
      >
        @for (tick of axisTicks; track $index) {
          <gr-skeleton-loader shape="pill" styleClass="gr-widget-loader-tick" />
        }
      </div>
    }
  }
</div>
